// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__ZxeNn","primary":"SubmitButton_primary__kUUiT"};